export default __webpack_public_path__ + "static/media/alert.44366455.svg";